import createVueApp from '@phoenix/createVueApp';
import { PhxGoogleMap, PhxGoogleMapMarker } from '@phx-styleguides/pia';

const app = createVueApp();
app.component('PhxGoogleMap', PhxGoogleMap);
app.component('PhxGoogleMapMarker', PhxGoogleMapMarker);
app.mount('#phoenix-google-map');
